import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./TransactionHistory.css";

import { useDispatch, useSelector } from "react-redux";
import { skeletonAction } from "../../Redux/Action/loadingAction";
import {
  getTransactionHistoryList,
} from "../../API/ApiService";
import TrasactionHistoryCard from "./TrasactionHistoryCard";
import NoTransaction from "./NoTransaction";

const TransactionHistory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [transactions, setTransactions] = useState([]);
  const [transactions1, setTransactions1] = useState([]);
  const [transactions2, setTransactions2] = useState([]);
  const [expandedCard, setExpandedCard] = useState(null);

  const skeletonLoad = useSelector(
    (state) => state?.loadingReducers?.skeletonLoader
  );

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  useEffect(() => {
    fetchTransactionHistory();
  }, []);

  useEffect(() => {
    const length = transactions.length;
    const halfLength = Math.ceil(transactions.length / 2);
    if (transactions && transactions.length > 0) {
      setTransactions1(transactions.slice(0, halfLength));
      setTransactions2(transactions.slice(halfLength, length));
    }
  }, [transactions]);

  const fetchTransactionHistory = async () => {
    try {
      dispatch(skeletonAction(true, "TRANSACTION_HISTORY"));
      const response = await getTransactionHistoryList();
      if (response?.status === 200) {
        setTransactions(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      dispatch(skeletonAction(false, "TRANSACTION_HISTORY"));
    }
  };

  const hasTransactions = transactions.length > 0;

  return (
    <div className="transaction-container">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <img
              src={"../images/back_btn.png"}
              alt="Back"
              height={25}
              width={76}
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer", marginTop: "35px" }}
            />
          </div>
          <div
            className="col-md-12"
            style={{ marginTop: "30px", marginBottom: "30px" }}
          >
            <h2>
              <span style={{ color: "#ffffff" }}>Transaction History</span>
            </h2>
          </div>
        </div>

        {skeletonLoad["TRANSACTION_HISTORY"] ? (
          // <div className="w-100 d-flex justify-content-between">
          <div className="transaction-wrapper">
            <div className="half-container">
              {Array(4)
                .fill(0)
                .map((_, index) => (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      height: "120px",
                      backgroundColor: "#333",
                      borderRadius: "8px",
                      marginBottom: "16px",
                      //  gap: "10px",
                      marginRight: "20px",
                    }}
                  />
                ))}
            </div>
            <div className="half-container">
              {Array(4)
                .fill(0)
                .map((_, index) => (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      height: "120px",
                      backgroundColor: "#333",
                      borderRadius: "8px",
                      marginBottom: "16px",
                      marginLeft: "20px",
                    }}
                  />
                ))}
            </div>
          </div>
        ) : hasTransactions ? (
          // <div className="w-100 d-flex justify-content-between">
          <div className="transaction-wrapper">
            <div className="half-container">
              <div className="transaction-list">
                {transactions1.map((transaction) => (
                  <TrasactionHistoryCard
                    key={transaction.business_uuid}
                    transaction={transaction}
                    transactions={transactions}
                    setTransactions={setTransactions}
                  />
                ))}
              </div>
            </div>
            <div className="half-container">
              <div className="transaction-list">
                {transactions2.map((transaction) => (
                  <TrasactionHistoryCard
                    key={transaction.business_uuid}
                    transaction={transaction}
                    transactions={transactions}
                    setTransactions={setTransactions}
                  />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="w-100">
            <NoTransaction />
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionHistory;
